import { render } from "./bag.svg?vue&type=template&id=4c4341ca"
const script = {}

import exportComponent from "C:\\Users\\craig\\Documents\\Websites\\lyle-scott\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__